import { useQuery } from '@tanstack/react-query';
import { useAppSelector } from '@/redux/hooks';
import { QueriesKeys } from '../queriesKeys';
import { rewardsApi } from './rewards.api';

export const useGroupedRewardsQuery = () => {
  const { userSession } = useAppSelector(state => state.user);

  return useQuery({
    queryKey: [QueriesKeys.rewardsGrouped],
    queryFn: () => rewardsApi.getGrouped(),
    enabled: userSession,
  });
};
